import { render, staticRenderFns } from "./LgSearchBar.vue?vue&type=template&id=041b4cf0"
import script from "./LgSearchBar.vue?vue&type=script&lang=js"
export * from "./LgSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports